module.exports = __webpack_public_path__ + "officialStatic/img/banbg.04de048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/banbg.png
// module id = Y0r6
// module chunks = 0